import { useThemeContext } from '@/contexts/ThemeContext';

export default function FeaturesSection() {
  const { theme } = useThemeContext();
  const features = theme.features;

  return (
    <section className="py-16 bg-coffee">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, i) => (
            <div key={i} className="flex items-start gap-4 p-6 bg-white/5 hover:bg-white/10 rounded-2xl transition-colors duration-300">
              <div className="w-11 h-11 flex-shrink-0 flex items-center justify-center bg-gold/20 rounded-xl">
                <i className={`${feature.icon} text-gold text-xl`} />
              </div>
              <div>
                <h3 className="text-sm font-semibold text-cream mb-1.5">{feature.title}</h3>
                <p className="text-xs text-cream/60 leading-relaxed">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
